import { styled } from '@mui/material/styles'
import { FormHelperText, Grid, Stack } from '@mui/material'
import { Controller, useForm } from 'react-hook-form'
import { FormProvider } from '../../common/hook-form'
import { useSnackbar } from 'notistack'
import { apiConstants, postGeneric } from '../../common/constants'
import { yupResolver } from '@hookform/resolvers/yup'
import * as Yup from 'yup'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import OtpInput from 'react-otp-input'
import { useState } from 'react'
import { Box } from '@mui/system'
import MUIModal from '../../common/MUIModal'
import { decodeAuthToken } from '../../helpers/UtilityHelper';
import { login, loginUserDataSlice } from "../../redux/userSlice";
import { fetchReportData } from "../../redux/actions/reportAction";


import {
  DividerText,
  ForgotPasswordButton,
  GoogleSignInButton,
  HeaderContainer,
  IconContainer,
  StyledDivider,
  StyledIcon,
  StyledLoadingButton,
  StyledTextFieldClient,
  SubTitle,
  WelcomeTitle,
} from './StyledElements'
import EmailIcon from '@mui/icons-material/Email';
import { Key, Phone, Send, VerifiedUser } from '@mui/icons-material'
import axios from 'axios'
import { userForgotPassword } from '../../redux/actions/auth/forgotPasswordAction'
import { useDispatch } from 'react-redux'

const InputStyle = {
  width: '50px',
  height: '50px',
  border: 'none',
}

const OtpContainer = styled(Box)(({ theme }) => ({
  '& input': {
    color: '#000',
    background: 'transparent',
    border: '1px solid #000 !important',
    borderRadius: 8,
    fontSize: 20,
    outline: 'none',
  },
  '& input:focus': {
    border: '1px solid #000 !important',
  },
}))

export default function Otp() {
  const { enqueueSnackbar } = useSnackbar()
  const navigate = useNavigate()
  const { state } = useLocation()
  const dispatch = useDispatch()
  const searchParams = new URLSearchParams(useLocation().search)
  const otpType = searchParams.get('type') || 'signup' // default to signup

  const [isLoading, setIsLoading] = useState(false)
  const [open, setOpen] = useState(false)
  const [mobile, setMobile] = useState(state?.contact_no)
  const [email, setEmail] = useState(state?.email)
  const [password, setPassword] = useState('')
  const resetPasswordTokenId = state?.mfaTokenId

  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        otpValidation: Yup.string().required('OTP is required'),
      })
    ),
    defaultValues: {
      otpValidation: '',
    },
  })

  const { handleSubmit } = methods

  const onVerify = () => {
    setIsLoading(true)
    const postData = {
      username: state.email,
      email: state.email,
      otp: {
        otpValue: methods.getValues().otpValidation,
      },
    }

    postGeneric(apiConstants.VERIFY_OTP, postData)
      .then(() => {
        setIsLoading(false)
        enqueueSnackbar('Signup Successful! An email has been sent to the email id with password', {
          variant: 'success',
        })
        navigate('/create-new-password', { state: state.email })
      })
      .catch((error) => {
        setIsLoading(false)
        enqueueSnackbar(error?.response?.data?.message || 'Oops Something went wrong!', {
          variant: 'error',
        })
      })
  }
  const onMFAVerify = async () => {
    setIsLoading(true)
    try {
      const postData = {
        username: state.email,
        "mfaTokenId": mfaTokenId || state.mfaTokenId,
        "otp": methods.getValues().otpValidation
      }
      const res = await postGeneric(apiConstants.VERIFY_MFA_OTP, postData)
      if (res.status === 200) {
        const { data: dataLogin } = res
        enqueueSnackbar('OTP verified successfully!', { variant: 'success' })
        setMfaTokenId(null)
        localStorage.setItem("userToken", dataLogin.accessToken);
        if (dataLogin.refreshToken) localStorage.setItem("refreshToken", dataLogin.refreshToken);
        dispatch(loginUserDataSlice({ ...dataLogin }))
        const { merchantOid, merchantList, roles, switchableMerchantOids } = decodeAuthToken(dataLogin.accessToken);
        const hasSwitchableMerchants = Array.isArray(switchableMerchantOids) && switchableMerchantOids.length > 0;
        if (hasSwitchableMerchants || (roles?.includes('ROLE_PROSHIPADMIN') && (merchantList === undefined || merchantList?.length === 0 || merchantList?.length > 0))) {
          let url = "/loginuser";
          navigate(url);
        }
        else {
          let merchantData;
          let config = {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + localStorage.getItem("userToken"),
            },
          };
          let merchantUrl =
            apiConstants.BASE_LOCAL + apiConstants.GET_MERCHANT_SEARCH;
          const { data } = await axios.post(
            merchantUrl,
            {
              offset: 0,
              limit: 1,
              orfilter: [],
              andfilter: [{ field: "id", operator: "eq", value: merchantOid }],
              excludes: "mappedOrderRule,sla",
            },
            config
          );
          merchantData = data.data[0];
          // delete merchantData.codRemittanceConfig;
          delete merchantData.mappedOrderRule;
          delete merchantData.wallet;
          delete merchantData.pickup_details;
          delete merchantData.bank_details;
          delete merchantData.alertSubscription;
          delete merchantData.gstDetails;
          delete merchantData.merchantWebHooks;
          delete merchantData.activeSlas;
          delete merchantData.alertSubscriptionB2B;
          const userInfo = { ...dataLogin, merchant: merchantData };
          dispatch(login(userInfo));
          dispatch(fetchReportData(merchantOid));
        }
      } else {
        enqueueSnackbar(res.error || 'OTP verification failed! Please try again.', { variant: 'error' })
      }
    } catch (error) {
      enqueueSnackbar(error?.response?.data?.message || 'Oops Something went wrong!', { variant: 'error' })
    } finally {
      setIsLoading(false)
    }
  }
  
  const onVerifyResetPassword = async () => {
    setIsLoading(true)

    const postData = {
      username: state?.email,
      otp: methods.getValues().otpValidation,
      tokenId: resetPasswordTokenId
    }

    try {
      // configure header's Content-Type as JSON
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
      };
      const url = `${apiConstants.BASE_LOCAL}${apiConstants.VERIFY_OTP_RESET_PASSWORD}`;

      const { data } = await axios.post(
        url,
        postData,
        config
      )
      if (data.status === "success") {
        enqueueSnackbar(data.message || 'OTP verified successfully! You can now reset your password.', {
          variant: 'success',
        })
        navigate('/')
      } else {
        enqueueSnackbar(data.message || 'OTP verification failed! Please try again.', {
          variant: 'error',
        })
      }
    } catch (error) {
      console.log('error', error)
      enqueueSnackbar(error?.response?.data?.message || 'Oops Something went wrong!', {
        variant: 'error',
      })
    } finally {
      setIsLoading(false)
    }

  }
  const handleOpen = () => {
    setOpen(true)
  }

  const resendCode = (number) => {
    const postData = {
      username: state.email,
      email: state.email,
      mobile: `+91${number}`,
    }
    postGeneric(apiConstants.GENERATE_OTP, postData)
      .then((a) => {
        enqueueSnackbar('Request sent', { variant: 'success' })
      })
      .catch((error) => {
        enqueueSnackbar(error?.response?.data?.message || 'Oops Something went wrong!', {
          variant: 'error',
        })
      })
    setOpen(false)
  }

  const resendCodeForgotPassword = async (email) => {
    setIsLoading(true)
    try {
      await dispatch(userForgotPassword({ username: email })).unwrap()
      enqueueSnackbar('OTP sent successfully!', { variant: 'success' })
      setOpen(false)
    } catch (error) {
      enqueueSnackbar(error || 'Failed to send OTP', { variant: 'error' })
    } finally {
      setIsLoading(false)
    }
  }

  const [mfaTokenId, setMfaTokenId] = useState(null)

  const resendCodeForMFA = async () => {
    setIsLoading(true)
    try {
      const loginUrl = `${apiConstants.BASE_LOCAL}${apiConstants.AUTH}`;
      const authResponse = await axios.post(
        loginUrl,
        { username: email, password: password, panel: "MERCHANT" },
        { headers: { "Content-Type": "application/json" } }
      );
      const { data: dataLogin } = authResponse;
      setMfaTokenId(dataLogin.mfaTokenId)
      enqueueSnackbar('OTP sent successfully!', { variant: 'success' })
      setOpen(false)
    } catch (error) {
      console.log("error", error);
      enqueueSnackbar(error?.response?.data?.error || 'Failed to send OTP', { variant: 'error' })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Box>
      <HeaderContainer>
        <WelcomeTitle variant='h4'>Verification Code</WelcomeTitle>
        <SubTitle variant='body1' color='text.secondary'>
          We have sent you the verfication code to your { otpType === 'mfa' ? 'registered email' : 'mobile number'}. OTP is valid for 10 minutes.
        </SubTitle>
      </HeaderContainer>

      <FormProvider methods={methods} onSubmit={handleSubmit(otpType === 'forgot-password' ? onVerifyResetPassword : otpType === 'mfa' ? onMFAVerify : onVerify)}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Controller
              name='otpValidation'
              control={methods.control}
              render={({ field, fieldState: { error } }) => {
                return (
                  <OtpContainer>
                    <OtpInput
                      containerStyle={{
                        justifyContent: 'space-between',
                      }}
                      value={field.value}
                      numInputs={6}
                      inputStyle={InputStyle}
                      {...field}
                      error={!!error}
                    />
                    {error ? <FormHelperText error>Invalid OTP</FormHelperText> : null}
                  </OtpContainer>
                )
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <Stack spacing={2}>
              <StyledLoadingButton
                size='large'
                type='submit'
                variant='contained'
                // disabled={watch('otpValidation').length !== 6}
                loading={isLoading}
                startIcon={<VerifiedUser />}
              >
                Verify OTP
              </StyledLoadingButton>
              <GoogleSignInButton
                onClick={() => handleOpen()}
                variant='outlined'
                fullWidth
                size='large'
                startIcon={<Send />}
              >
                Resend OTP
              </GoogleSignInButton>

              <StyledDivider>
                <DividerText variant='body2' color='text.secondary'>
                  OR
                </DividerText>
              </StyledDivider>
              <ForgotPasswordButton variant='text' component={Link} to='/login'>
                Back to Login
              </ForgotPasswordButton>
            </Stack>
          </Grid>
        </Grid>
      </FormProvider>
      <MUIModal
        sx={{
          '& .MuiDialog-paper': {
            background: 'rgb(238, 242, 246)',
          },
          '& .MuiDialogTitle-root': {
            color: '#000',
            fontWeight: 400,
          },
          '& .MuiDialogActions-root': {
            '& .MuiButton-root': {
              color: '#000',
            },
          },
        }}
        open={open}
        maxWidth='xs'
        title={otpType === 'forgot-password' || otpType === 'mfa' ? 'Update Email for OTP' : 'Update Mobile Number for OTP'}
        handleClose={() => setOpen()}
      >
        <Grid container spacing={3} sx={{ mt: '1px' }}>
          {otpType === 'forgot-password' ? (
            <>
              <Grid item xs={12}>
                <StyledTextFieldClient
                  sx={{
                    '& .MuiInputBase-root': {
                      borderRadius: '8px !important',
                    },
                  }}
                  InputProps={{
                    startAdornment: (
                      <IconContainer>
                        <StyledIcon>
                          <EmailIcon />
                        </StyledIcon>
                      </IconContainer>
                    ),
                  }}
                  label='Email'
                  placeholder='Please Enter Your Valid Email'
                  fullWidth
                  defaultValue={state?.email}
                  onChange={(e) => {
                    setEmail(e.target.value)
                  }}
                />
              </Grid>
            </>
          ) : otpType === 'mfa' ? (
            <>
              <Grid item xs={12}>
                <StyledTextFieldClient
                  sx={{
                    '& .MuiInputBase-root': {
                      borderRadius: '8px !important',
                    },
                  }}
                  InputProps={{
                    startAdornment: (
                      <IconContainer>
                        <StyledIcon>
                          <EmailIcon />
                        </StyledIcon>
                      </IconContainer>
                    ),
                  }}
                  label='Email'
                  placeholder='Please Enter Your Valid Email'
                  fullWidth
                  defaultValue={state?.email}
                  onChange={(e) => {
                    setEmail(e.target.value)
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <StyledTextFieldClient
                  sx={{
                    '& .MuiInputBase-root': {
                      borderRadius: '8px !important',
                    },
                  }}
                  InputProps={{
                    startAdornment: (
                      <IconContainer>
                        <StyledIcon>
                          <Key />
                        </StyledIcon>
                      </IconContainer>
                    ),
                  }}
                  label='Password'
                  placeholder='Please Enter Your Password'
                  fullWidth
                  onChange={(e) => {
                    setPassword(e.target.value)
                  }}
                />
              </Grid>
            </>
          ) : (
            <>
              <Grid item xs={12}>
                <StyledTextFieldClient
                  sx={{
                    '& .MuiInputBase-root': {
                      borderRadius: '8px !important',
                    },
                  }}
                  InputProps={{
                    startAdornment: (
                      <IconContainer>
                        <StyledIcon>
                          <Phone />
                        </StyledIcon>
                      </IconContainer>
                    ),
                  }}
                  label='Mobile Number'
                  placeholder='Please Enter Your Valid Mobile Number'
                  fullWidth
                  defaultValue={mobile}
                  onChange={(e) => {
                    setMobile(e.target.value)
                  }}
                />
              </Grid>
            </>
          )}
          <Grid item xs={12}>
            <StyledLoadingButton
              startIcon={<Send />}
              variant='contained'
              onClick={() => otpType === 'forgot-password' ? resendCodeForgotPassword(email) : otpType === 'mfa' ? resendCodeForMFA(email, password) : resendCode(mobile)}
            >
              Send OTP
            </StyledLoadingButton>
          </Grid>
        </Grid>
      </MUIModal>
    </Box>
  )
}
